export const verify = {
    methods:{
        verifyData(){
            if( this.currentTask.currentType == 'single_choice' || (this.currentTask.currentType == 'material' && this.getMaterialType()[this.currentTask.currentIndex] == 'single_choice') ){
                if(!this.defaultVal.single_choice.title){
                    this.$message.error('请填写题目')
                    return false
                }
                if(!this.defaultVal.single_choice.A){
                    this.$message.error('请编辑A选项')
                    return false
                }
                if(!this.defaultVal.single_choice.B){
                    this.$message.error('请编辑B选项')
                    return false
                }
                if(!this.defaultVal.single_choice.C){
                    this.$message.error('请编辑C选项')
                    return false
                }
                if(this.currentTask.currentType == 'material' && !this.stem){

                    this.$message.error('请输入题干')
                    return false
                }
                return true
            }
            if(this.currentTask.currentType == 'multiple_choice' || (this.currentTask.currentType == 'material' && this.getMaterialType()[this.currentTask.currentIndex] == 'multiple_choice')){
                if(!this.defaultVal.multiple_choice.title){
                    this.$message.error('请填写题目')
                    return false
                }
                if(!this.defaultVal.multiple_choice.consult.length){
                    this.$message.error('请确定选项')
                    return false
                }
                if(this.defaultVal.multiple_choice.consult.length){
                    for(let item of this.defaultVal.multiple_choice.consult){
                        if(!this.defaultVal.multiple_choice[item]){
                            this.$message.error('请编辑选项')
                            return false
                        }
                    }
                }
                if(this.currentTask.currentType == 'material' && !this.stem){
                    this.$message.error('请输入题干')
                    return false
                }
                return true
            }
            if(this.currentTask.currentType == 'fill'  || (this.currentTask.currentType == 'material' && this.getMaterialType()[this.currentTask.currentIndex] == 'fill')){
                if(!this.defaultVal.fill.title){
                    this.$message.error('请填写题目')
                    return false
                }
                if(this.currentTask.currentType == 'material' && !this.stem){
                    this.$message.error('请输入题干')
                    return false
                }
                return true
            }
            if(this.currentTask.currentType == 'jud_question'  || (this.currentTask.currentType == 'material' && this.getMaterialType()[this.currentTask.currentIndex] == 'jud_question')){
                if(!this.defaultVal.jud_question.title){
                    this.$message.error('请填写题目')
                    return false
                }
                if(this.currentTask.currentType == 'material' && !this.stem){
                    this.$message.error('请输入题干')
                    return false
                }
                return true
            }
            if(this.currentTask.currentType == 'answer'  || (this.currentTask.currentType == 'material' && this.getMaterialType()[this.currentTask.currentIndex] == 'answer')){
                if(!this.defaultVal.answer.title){
                    this.$message.error('请填写题目')
                    return false
                }
                if(this.currentTask.currentType == 'material' && !this.stem){
                    this.$message.error('请输入题干')
                    return false
                }
                return true
            }
        },
        resetData(){
            this.defaultVal={
                single_choice:{
                    title:'',
                    titleImg:'',
                    A:'',
                    B:'',
                    C:'',
                    D:'',
                    consult:'A',
                    consultImg:'',
                    analysis:'',
                    point:'',
                },
                multiple_choice:{
                    title:'',
                    titleImg:'',
                    A:'',
                    B:'',
                    C:'',
                    D:'',
                    consult:[],
                    consultImg:'',
                    analysis:'',
                    point:''
                },
                fill:{
                    title:'',
                    titleImg:'',
                    consult:'',
                    consultImg:'',
                    analysis:'',
                    point:''
                },
                jud_question:{
                    title:'',
                    titleImg:'',
                    consult: '1',
                    consultImg:'',
                    consultCont:'',
                    analysis:'',
                    point:''
                },
                answer:{
                    title:'',
                    titleImg:'',
                    consult: '',
                    consultImg:'',
                    analysis:'',
                    point:''
                },
                material:{
                    title:'',
                    titleImg:'',
                    consultImg:'',
                    consult: '',
                    analysis:'',
                    point:''
                }
            }
        },
    }
}
